import { Empty, PageHeader, Popconfirm, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import AgregarCirugia from "./AgregarCirugia/AgregarCirugia";
import EditarCirugia from "./EditarCirugia/EditarCirugia";

moment.locale("es");

class Cirugias extends Component {
  state = {
    modalAgregar: false,
    modalEditar: false,
    todosCirugias: [],
    loading: false,
    doctorId: null,
  };

  // Abrir modal para agregar
  abrirAgregarCirugia(){
    this.setState({ modalAgregar: true, cirugiaId: null });
  };

  // Cerrar modal de agregar
  cerrarAgregarCirugia(){
    this.setState({ modalAgregar: false });
    this.consultarTodasCirugias();
  };

  // Abrir modal para editar
  abrirEditarCirugia(cirugiaId){
    this.setState({ modalEditar: true, cirugiaId: cirugiaId });
  };

  // Cerrar modal de editar
  cerrarEditarCirugia(){
    this.setState({ modalEditar: false });
    this.consultarTodasCirugias();
  };

  componentDidMount() {
    this.consultarTodasCirugias();
  }

  consultarTodasCirugias() {
    this.setState({ loading: true });
    axios
      .post(
        "cirugias/selectTodasCirugias",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            todosCirugias: res.data.cirugias
          });
        } else {
          message.error("Error no se encotraron Cirugias");
        }
      });
  }

  // Deshabilita una cirugia
  deshabilitarCirugia(id) {
    axios
      .post(
        "cirugias/deshabilitarCirugia",
        { cirugiaId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Cirugia deshabilitada exitosamente");
          this.consultarTodasCirugias();
        } else if (res.data.success === 1){
          message.error("Error al deshabilitar la cirugia");
        }else{
          message.error("Error");
        }
      });
  }

  // Habilita una Cirugia
  habilitarCirugia(id) {
    axios
      .post(
        "cirugias/habilitarCirugia",
        { cirugiaId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Cirugia habilitada exitosamente");
          this.consultarTodasCirugias();
        } else if (res.data.success === 1){
          message.error("Error al habilitar la cirugia");
        }else{
          message.error("Error");
        }
      });
  }

  render() {
    const columns = [
      {
        title: "Código",
        dataIndex: "codigo",
        key: "codigo",
        sorter: (a, b) => {
          if (a.codigo < b.codigo) {
            return -1;
          }
          if (a.codigo > b.codigo) {
            return 1;
          }
          return 0;
        },
        buscar: "codigo",
      },
      {
        title: "Cirugía",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
            },
      {
        title: "Acción",
        key: "accion",
        align: "center",
        width: "20%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (record, index) => {
          let buttons = [];

          buttons.push(
            <Tooltip 
              title="Editar Cirugía" 
              placement="top" 
              overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
            >
              <ButtonItem
                key={`editar-${index}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.abrirEditarCirugia(record._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${index}`}
                title="¿Seguro que quieres deshabilitar esta cirugía?"
                onConfirm={() => this.deshabilitarCirugia(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip 
                  title="Deshabilitar" 
                  placement="top" 
                  overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${index}`}
                title="¿Seguro que quieres habilitar esta cirugía?"
                onConfirm={() => this.habilitarCirugia(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip 
                  title="Habilitar" 
                  placement="top" 
                  overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      }
    ];

    return (
      <>
        <PageHeader
          title="Cirugías"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <ButtonItem
              type="primary"
              key="agregarCirugia"
              olivo
              onClick={this.abrirAgregarCirugia.bind(this)}
               className="botonAgregar"
            >
              Agregar Cirugía
            </ButtonItem>
          }
        />
        <TableItem
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <>
                    <p>
                      No hay registros de Cirugias. Aquí puedes gestionar y
                      llevar un control de las Cirugias.
                    </p>
                  </>
                }
              />
            ),
          }}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todosCirugias}
          columns={columns}
          pagination={false}
        />
        <AgregarCirugia
          visible={this.state.modalAgregar}
          cerrarAgregarCirugia={this.cerrarAgregarCirugia.bind(this)}
        />
        <EditarCirugia
          visible={this.state.modalEditar}
          cerrarEditarCirugia={this.cerrarEditarCirugia.bind(this)}
          cirugiaId={this.state.cirugiaId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Cirugias);
